module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-new right-info-block",
    attrs: {
      "id": "order-help-section"
    }
  }, [_c('i', {
    staticClass: "ion-ios-information-outline"
  }), _vm._v(" "), _c('h2', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 1),
      expression: "step == 1"
    }]
  }, [_vm._v("Punkt podjęcia")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 1),
      expression: "step == 1"
    }],
    staticClass: "single-info"
  }, [_c('h3', [_vm._v("1")]), _vm._v(" "), _c('p', [_vm._v("Wybierz salon podjęcia dostępny z widocznej obok listy, następnie przejdź dalej")])]), _vm._v(" "), _c('h2', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 2),
      expression: "step == 2"
    }]
  }, [_vm._v("Adres realizacji")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 2),
      expression: "step == 2"
    }],
    staticClass: "single-info"
  }, [_c('h3', [_vm._v("1")]), _vm._v(" "), _c('p', [_vm._v("Wprowadź adres realizacji usługi, który jest krokiem niezbędnym w wyliczeniu trasy przejazdu, a także kosztów transportu.")]), _vm._v(" "), _c('p', [_vm._v("Przed przejściem dalej sprawdź poprawność danych.")])]), _vm._v(" "), _c('h2', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 3),
      expression: "step == 3"
    }]
  }, [_vm._v("Szczegóły")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 3),
      expression: "step == 3"
    }],
    staticClass: "single-info"
  }, [_c('h3', [_vm._v("1")]), _vm._v(" "), _c('p', [_vm._v("Wpisz numer zamówienia i jego wartość, następnie wciśnij przycisk \"Dodaj\". Krok ten jest niezbędny do obliczenia kosztów transportu.")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 3),
      expression: "step == 3"
    }],
    staticClass: "single-info"
  }, [_c('h3', [_vm._v("2")]), _vm._v(" "), _c('p', [_vm._v("W przypadku większej ilości zamówień dodaj kolejne zamówienia postepując zgodnie z pkt. 1.")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 3),
      expression: "step == 3"
    }],
    staticClass: "single-info"
  }, [_c('h3', [_vm._v("3")]), _vm._v(" "), _c('p', [_vm._v("Wybierz preferowaną datę realizacji spośród dostępnych terminów. W przypadku wyboru innego terminu realizacji, wybierz opcję \"Inny termin\", a następnie wpisz preferowany termin realizacji.")]), _vm._v(" "), _c('p', [_vm._v("UWAGA! Podane terminy są najbliższymi możliwymi")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 3),
      expression: "step == 3"
    }],
    staticClass: "single-info"
  }, [_c('h3', [_vm._v("4")]), _vm._v(" "), _c('p', [_vm._v("Wybierz preferowany przedział godzinowy dostawy.")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 3),
      expression: "step == 3"
    }],
    staticClass: "single-info"
  }, [_c('h3', [_vm._v("5")]), _vm._v(" "), _c('p', [_vm._v("Po uzupełnieniu wszystkich danych przejdź dalej do podsumowania.")])]), _vm._v(" "), _c('h2', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 4),
      expression: "step == 4"
    }]
  }, [_vm._v("Podsumowanie")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.step == 4),
      expression: "step == 4"
    }],
    staticClass: "simple-paragraph"
  }, [_c('p', [_vm._v("Prosimy o sprawdzenie poprawności uzupełnionych danych, a następnie wprowadzenie danych osobowych wraz z numerem telefonu i adresem mailowym na który wysłane zostanie potwierdzenie złożenia zamówienia wraz z linkiem do płatności.")]), _vm._v(" "), _c('p', [_vm._v("Jeśli wszystkie wprowadzone przez Ciebie dane zgadzają się, możesz zakończyć proces rejestracji zamówienia dostawy. W przeciągu 5 minut otrzymasz potwierdzenie smsowe, a także mail z podsumowaniem zamówienia zawierający link do płatności online, dzięki któremu będziesz mógł dokonać opłaty za transport w wygodny dla siebie sposób.")]), _vm._v(" "), _c('p', [_vm._v("Dziękujemy za skorzystanie z usług DTS i życzymy miłego dnia!")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35fc2a98","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HelpSection.vue
// module id = 248
// module chunks = 1